import styled from 'styled-components';

import { Link, hideVisually, zIndex } from '@comicrelief/component-library';

const Navigation = styled.nav`
  display: ${({ isMenuOpen }) => (isMenuOpen ? 'block' : 'none')};
  position: absolute;
  top: 75px;
  left: 0;
  ${zIndex('higher')};
  overflow: hidden auto;
  width: 100%;

  // Full-height minus the header itself PLUS a little extra
  // allowing us to scroll down the bottom li in each ul:
  height: calc(100vh - 150px);

  // * iOS scrollbar overlap fix *
  // Increase the width of the container slightly:
  width: calc(100% + 20px);

  // Use a negative margin to reposition:
  margin-left: -10px;

  // Then use the extra space to add some padding, to ensure any annoying
  // "inside" scrollbars (notably iOS/Webkit) won't overlap the content:
  padding-inline: 10px;

  @media ${({ theme }) => theme.breakpoints2026('L')} {
    ${zIndex('medium')};
    position: static;
    top: 0;
    display: block;
    height: 100%;
    box-shadow: none;
    overflow: visible;

    // Reset the tweaks:
    width: 100%;
    margin: 0;
    padding-inline: 0px;
  }

  // Accessibility aid
  > h2 {
    ${hideVisually};
  }
`;

const PrimaryMenuWrapper = styled.div`
  background-color: ${({ theme }) => theme.color('white')};
  box-shadow: ${({ $hideContainer }) => ($hideContainer ? 'none' : '0 5px 20px 0 rgba(0, 0, 0, 0.05)')};
  border-radius: ${({ $hideContainer }) => ($hideContainer ? '0' : '16px')};
  border: ${({ $hideContainer, theme }) => ($hideContainer ? 'none' : `1px solid ${theme.color('grey_medium')}`)};
  overflow: hidden;
  position: static;

  @media ${({ theme }) => theme.breakpoints2026('L')} {
    box-shadow: none;
    border-radius: 0;
    border: none;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: visible;
  }
`;

const PrimaryMenu = styled.ul`
  background-color: transparent;
  list-style: none outside;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;

  @media ${({ theme }) => theme.breakpoints2026('L')} {
    position: static;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    max-width: 750px;
    height: 100%;
    background-color: ${({ theme }) => theme.color('white')};
  }
`;

const DonateButtonMobileModalWrapper = styled.div`
  display: block;
  background-color: inherit;
  margin-top: 48px;
  width: 100%;

  // Donate button
  a {
    box-sizing: border-box;
    display: block;
    text-align: center;
    border-radius: 16px;
    width: 100%;
    margin: 0;
    font-family: Montserrat;
    height: auto;
    padding: 18px 0;

    &:hover,
    &:focus {
      width: 100%;
      box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
    }
  }

  // Hide the 'Nav'-embedded version of the button when the nav
  // goes FULL DESKTOP, leaving just the 'Header'-embedded example
  @media ${({ theme }) => theme.breakpoints2026('L')} {
    display: none;
  }
`;

const SearchWrapperMobile = styled.div`
  display: block;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.color('grey_medium')};

  @media ${({ theme }) => theme.breakpoints2026('L')} {
    display: none;
  }
`;

const SearchLinkMobile = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 25px;
  line-height: 1rem;
  width: 100%;
  text-decoration: none;
  font-family: Montserrat;
  font-weight: 600;
  color: ${({ theme }) => theme.color('black')};
  transition: color 0.2s ease;
  outline-offset: -3px;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.color('red')};
    background-color: ${({ theme }) => theme.color('grey_extra_light')};
  }
`;

const SearchIconWrapperMobile = styled.span`
  overflow: visible;

  img {
    width: 1rem;
    height: 1rem;
    transition: transform 0.2s ease;
    transform-origin: center;
  }

  a {
    overflow: visible;
    display: block;
  }

  &:hover img,
  &:focus-within img {
    transform: scale(1.33);
  }

  @media ${({ theme }) => theme.breakpoints2026('L')} {
    display: none;
  }
`;

export {
  Navigation,
  PrimaryMenuWrapper,
  PrimaryMenu,
  DonateButtonMobileModalWrapper,
  SearchWrapperMobile,
  SearchLinkMobile,
  SearchIconWrapperMobile
};
